import { Component, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LogServiceFe, User } from '@erbsen/shared/data-access';
import { ButtonModule } from 'primeng/button';

@Component({
  imports: [RouterModule, ButtonModule],
  selector: 'erb-root',
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class App implements OnInit {
  private logService = inject(LogServiceFe);

  currentUser: User = {
    id: '1',
    name: 'Chris',
    email: 'chris@erbsen.de',
    roles: ['admin'],
    createdAt: new Date(),
    lastLogin: new Date(),
    lastLogout: null,
  };
  protected title = 'user-shell';
  triggerMessage = '';
  private triggerMessageTimer?: ReturnType<typeof setTimeout>;

  ngOnInit(): void {
    this.logService
      .info('User shell started', {
        component: 'App',
        metadata: { title: this.title },
      })
      .subscribe();
  }

  triggerLog(): void {
    this.logService
      .info('trigger pressed in user-shell', {
        component: 'App',
      })
      .subscribe({
        next: () => this.setTriggerMessage('Trigger logged.'),
        error: () => this.setTriggerMessage('Trigger failed. Try again.'),
      });
  }

  private setTriggerMessage(message: string): void {
    this.triggerMessage = message;
    if (this.triggerMessageTimer) {
      clearTimeout(this.triggerMessageTimer);
    }
    this.triggerMessageTimer = setTimeout(() => {
      this.triggerMessage = '';
    }, 2000);
  }
}
